import {
	Disclosure,
	DisclosureButton,
	DisclosurePanel,
} from '@headlessui/react';
import clsx from 'clsx';

import type { ITrainingProgramm } from '../../types';

export const TrainingProgramm = ({
	programs,
}: {
	programs: ITrainingProgramm['programs'];
}) => {
	return (
		<div className="flex flex-col gap-2 md:grid-cols-3">
			{programs.map((item, key) => {
				const labelClassName = clsx(
					'mb-3 inline-block rounded-full px-2 py-0.5 text-[10px]/[1.2]',
					'xl:absolute xl:right-5 xl:top-5 xl:px-[10px] xl:py-[5px] xl:text-xs/[1.2] xl:uppercase',
					'2xl:right-12 2xl:top-8',
					{
						'bg-[#41B522] text-white': item.variant === 'green',
						'bg-[#F1F1F4] text-[#4B5675]': item.variant === 'gray',
						'bg-[#0149FF] text-white': item.variant === 'primary',
					},
				);
				return (
					<Disclosure key={key} defaultOpen={key === 0}>
						<div className="relative rounded-2xl border-2 border-[#DBDFE9] bg-white text-[#252F4A] xl:rounded-3xl 2xl:rounded-[40px]">
							<DisclosureButton className="group flex w-full flex-col items-start p-4 xl:p-6 2xl:px-12 2xl:py-8">
								<ul className="flex flex-row flex-wrap gap-2 text-base/[1.4] text-[#99A1B7] max-xl:hidden xl:pr-[140px]">
									{item.labels
										.reduce<string[]>(
											(acc, val) => (acc.length ? [...acc, '/', val] : [val]),
											[],
										)
										.map((label, k) => (
											<li key={k}>{label}</li>
										))}
								</ul>
								<span className={labelClassName}>• {item.label}</span>
								<div className="mt-1 text-left text-base/[1.2] font-semibold xl:text-2xl 2xl:text-[32px]/[1.3]">
									{item.title}
								</div>
							</DisclosureButton>
							<DisclosurePanel className="-mt-4 px-4 pb-4 xl:-mt-5 xl:px-6 xl:pb-6 2xl:-mt-8 2xl:px-12 2xl:pb-8">
								<ul className="flex flex-col gap-2 text-sm/[1.4] text-[#99A1B7] xl:hidden">
									{item.labels.map((label, k) => (
										<li key={k}>{label}</li>
									))}
								</ul>
								<div className="mt-4 flex flex-col gap-6 xl:mt-10 xl:flex-row xl:justify-between xl:gap-6">
									{item.items.map(({ title, content }, k) => (
										<div
											key={k}
											className="text-xs/[1.2] text-[#4B5675] xl:flex-1 xl:text-sm/[1.2]"
										>
											<h3 className="text-sm/[1.3] font-semibold text-[#252F4A] xl:text-base/[1.2]">
												{title}
											</h3>
											{Array.isArray(content) ? (
												<ul className="ml-4 mt-4 list-disc space-y-2">
													{content.map((c, k) => (
														<li key={k}>{c}</li>
													))}
												</ul>
											) : (
												<p className="mt-4">{content}</p>
											)}
										</div>
									))}
								</div>
								<p className="mt-4 text-sm/[1.2] font-semibold text-[#4B5675] xl:mt-10 xl:text-base/[1.2]">
									{item.text}
								</p>
							</DisclosurePanel>
						</div>
					</Disclosure>
				);
			})}
		</div>
	);
};
